import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { AuthProvider } from "./lib/AuthContext";
import { Toaster } from "sonner";
import Navbar from "./components/Navbar";
import Home from "./pages/Home";
import Login from "./pages/Login";
import Register from "./pages/Register";
import Category from "./pages/Category";
import Thread from "./pages/Thread";
import Search from "./pages/Search";
import Profile from "./pages/Profile";
import Membership from "./pages/Membership";
import Admin from "./pages/Admin";
import { PaymentSuccess, PaymentCancel } from "./pages/PaymentResult";

export default function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AuthProvider>
          <Navbar />
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/login" element={<Login />} />
            <Route path="/register" element={<Register />} />
            <Route path="/category/:categoryId" element={<Category />} />
            <Route path="/thread/:threadId" element={<Thread />} />
            <Route path="/search" element={<Search />} />
            <Route path="/profile/:userId" element={<Profile />} />
            <Route path="/membership" element={<Membership />} />
            <Route path="/admin" element={<Admin />} />
            <Route path="/payment-success" element={<PaymentSuccess />} />
            <Route path="/payment-cancel" element={<PaymentCancel />} />
          </Routes>
          <Toaster
            position="top-right"
            toastOptions={{
              style: {
                border: "2px solid #121212",
                borderRadius: "12px",
                background: "white",
                color: "#121212",
                fontWeight: 600,
                boxShadow: "4px 4px 0 0 #121212",
              },
            }}
          />
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}
